import React from "react";
import GenericFilter from "../../GenericFilter";
import { useAlertsFiltersContext } from "../AlertsFiltersProvider";
import styles from "./index.module.scss";
import Select from "../../Dropdown/Select";
import { OptionType } from "../../../types/GeneralTypes";
import ResultsCount from "../../ResultsCount";
import { eventsLimit } from "../../../helpers/pagination";

const DesktopFilters = ({
  eventsCount,
  totalEvents
}: {
  eventsCount: number;
  totalEvents: number;
}) => {
  const {
    eventTypeOptions,
    selectedEventTypes,
    setSelectedEventTypes,
    sortByOptions,
    sortBy,
    setSortBy,
    page
  } = useAlertsFiltersContext();
  console.log("eventTypeOptions", eventTypeOptions);
  console.log("selectedEventTypes", selectedEventTypes);

  return (
    <div className={styles.Wrapper}>
      <GenericFilter
        label={"Events"}
        options={eventTypeOptions}
        selectedItems={selectedEventTypes}
        setSelectedItems={setSelectedEventTypes}
      />

      <div className={styles.ResponsiveGap} />

      <ResultsCount
        totalEvents={totalEvents}
        eventsCount={eventsCount}
        page={page}
        className={styles.ResultsCount}
        limit={eventsLimit}
      />

      <Select
        label={"Sort By:"}
        items={sortByOptions}
        onChange={(sort: OptionType) => setSortBy(sort.value)}
        initial={
          sortByOptions.find(option => sortBy === option.value) || {
            value: "",
            label: ""
          }
        }
      />
    </div>
  );
};

export default DesktopFilters;
